import { default as lebronjames } from './lebronjames.jpg'
import { default as michaeljordan } from './jordan.jpg'
import { default as kobebryant } from "./kobebryant.jpg";
import { default as shaquilleoneal } from "./shaq.jpg";
import { default as wiltchamberlain} from "./wilt.jpg";
import { default as larrybird } from "./bird.jpg";
import { default as magicjohnson } from "./magic.jpg";
import { default as kareemjabbar } from "./kareem.jpg";
import { default as hakeemlajuwon } from "./hakeem.jpg";
import { default as timduncan } from "./duncan.jpg";
import { default as billrussell } from "./bill.jpg";
import { default as stephencurry } from "./steph.jpg";

const playersObj = [
    {name: "LeBron James", image: lebronjames},
    {name: "Michael Jordan", image: michaeljordan},
    {name: "Kobe Bryant", image: kobebryant},
    {name: "Shaquille O'Neal", image: shaquilleoneal},
    {name: "Wilt Chamberlain", image: wiltchamberlain},
    {name: "Larry Bird", image: larrybird},
    {name: "Magic Johnson", image: magicjohnson},
    {name: "Kareem Abdul Jabbar", image: kareemjabbar},
    {name: "Hakeem Olajuwon", image: hakeemlajuwon},
    {name: "Tim Duncan", image: timduncan},
    {name: "Bill Russell", image: billrussell},
    {name: "Stephen Curry", image: stephencurry}
]

export default playersObj;